<template>
  <!-- 
    * Copyright: T-Systems México S.A. de C.V.
    * Descripción: Vista Usuarios, permite consultar, agregar, editar y eliminar roles de usuarios 
    * Autor: Omar Enrique Ramos Gonzalez
  -->
  <layout>
    <template v-slot:content>
      <!-- Tabla para mostrar contenido -->
      <v-data-table
        :headers="headers"
        :items="users"
        :loading="isLoading"
        loading-text="Cargando elementos en tabla"
        class="elevation-1"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title>{{$t('tblTitle')}}</v-toolbar-title>
            <v-divider
              class="mx-4"
              inset
              vertical
            ></v-divider>
            <v-select
              v-model="filter"
              :items="profiles"
              attach
              item-value="id"
              item-text="name"
            ></v-select>
            <v-spacer></v-spacer>
            <!-- Dialogo emergente -->
            <v-dialog persistent v-model="dialog" max-width="500px">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                color="primary"
                dark
                class="mb-2"
                v-bind="attrs"
                v-on="on"
                >{{$t('tblbutton')}}</v-btn>
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>
                <!-- Contenido de formulario -->
                <v-card-text>
                  <v-container>
                    <v-form ref="form">
                      <v-text-field 
                        v-model="editedItem.email"
                        :label="$t('lblEmail')"
                        :rules="[(v) => !v || /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid']"
                        :counter="10"
                      ></v-text-field>
                      <v-select
                        v-model="editedItem.profiles"
                        :items="profiles"
                        :rules="[(v) => v.length > 0 || 'Role is required']"
                        attach
                        chips
                        :label="$t('lblRole')"
                        item-value="id"
                        item-text="name"
                        multiple
                      ></v-select>
                    </v-form>
                  </v-container>
                </v-card-text>
                <!-- Enviar formulario -->
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" text @click.stop="close">{{$t('mdlCancel')}}</v-btn>
                  <v-btn color="primary" text @click="save">{{$t('mdlSave')}}</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-icon
            small
            class="mr-2"
            @click="editItem(item)"
          >
            mdi-pencil
          </v-icon>
          <v-icon
            v-if="canDelete(item.mail)"
            small
            @click="deleteItem(item)"
          >
            mdi-delete
          </v-icon>
        </template>
      </v-data-table>
      <v-snackbar v-model="snackbar">
        {{ snackbarMessage }}
        <v-btn color="primary" text @click="snackbar = false">Cerrar</v-btn>
      </v-snackbar>
    </template>
  </layout>
</template>

<script>
import Layout from "@/components/Layouts/company";
import i18nMessages from "./i18n.messages";
import { mapGetters } from "vuex";
import { Auth } from "aws-amplify";

  export default {
    i18n: i18nMessages,
    components: {
      layout: Layout
    },
    props: {
      source: String,
    },
    data: () => ({
      email: '',
      dialog: false,
      filter: 2,
      headers: [
        {
          id: 'headerUsername',
          text: 'Usuario',
          align: 'start',
          sortable: false,
          value: 'username',
        },
        { id:'headerName', text: 'Nombre', value: 'name' },
        { id:'headerMail', text: 'E-mail', value: 'mail' },
        { id:'headerRole', text: 'Rol', value: 'roles', sortable: false },
        { id:'headerAction', text: 'Acciones', value: 'actions', sortable: false },
      ],
      users: [],
      profiles: [],
      editedIndex: -1,
      editedItem: {
        id: 0,
        email: '',
        profiles: [2],
      },
      defaultItem: {
        id: 0,
        emial: '',
        profiles: [2],
      },
      snackbar: false,
      snackbarMessage : '',
    }),

    created () {
      this.$i18n.locale = this.locale;
      this.updateHeadersLocale();
      this.loadProfiles();
      // Obtiene el email de usuario
      Auth.currentAuthenticatedUser().then(data => {
        this.email = data.signInUserSession.idToken.payload.email;
      });
    },

    computed: {
      ...mapGetters(["isLoading"]),
      locale() {
        return this.$store.getters["locale"];
      },
      formTitle () {
        return this.editedIndex === -1 ? this.$t('dlgAddTitle') : this.$t('dlgUploadTitle');
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      filter (val) {
        this.loadUsers(val);
      },
      locale (value) {
        this.$i18n.locale = value;
        this.updateHeadersLocale();
      }
    },

    methods: {
      // Actualiza el idioma de los encabezados de la tabla
      updateHeadersLocale() {
        this.headers = this.headers.map(header => {
          header.text = this.$t(header.id);
          return header;
        });
      },
      /**
       * Carga la lista de usuarios de acueroda al tippo de perfil
       * @param profile Id del perfil
       */
      loadUsers(profile) {
        let settings = {
          profile: profile
        };
        this.$GET('/api/profiles/{{profile}}/users', settings)
        .then(data => {
          this.users = data.map(item => {
            return {
              id: item.id,
              username: item.username,
              name: item.name,
              mail: item.email,
              userProfiles: item.userProfiles,
              roles: item.userProfiles.map(profile =>{
                return this.getProfielName(profile.profileId);
              }),
              profiles: item.userProfiles.map(profile =>{
                return profile.profileId;
              })
            };
          });
        console.log("MeetingRooms: ", this.meetingRooms);
        })
        .catch(e => {
          console.log(e)
        });
      },
      /**
       * Obtiene el nombre del perfil de la lista de perfile
       * @param profileId Id del perfil
       */
      getProfielName(profileId){
        let profile = this.profiles.find( role => role.id == profileId);
        return profile ? profile.name : '';
      },
      /**
       * Muestra el cuadro de editar
       */
      editItem (item) {
        this.editedIndex = this.users.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },
      /**
       * Muestra el cuadro de confiurmacion
       */
      deleteItem (item) {
        confirm(this.$t('lbldelete1')) && this.delete(item)
      },
      /**
       * Cierra el cuadro de editar/agregar
       */
      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },
      /**
       * Metodo para salvar cambios realizados
       */
      save () {
        if (this.editedItem.email == null || this.editedItem.email == '' || this.editedItem.profiles == []) {
          // Error de validacion, muestra mensaje
          this.snackbarMessage = "Corrige errores de validación, debes llenar todos los campos";
          this.snackbar = true;
        } else{
          // Flujo normal
          if (this.editedIndex > -1) {
            // Edita el elemento seleccionado
            this.edit(this.editedItem);
          } else {
            // Agrega un nuevo usuario
            this.addProfile(this.editedItem);
          }
          this.close()
        }
      },
      /**
       * Metodo que agrega un usuario al sistema
       * @param item Objeto coon los datos del usuario
       */
      addProfile(item){
        // Llama a la Lambda getUser para saber si el usuario existe
        let settings = {
          email: item.email
        };
        this.$GET('/api/users/email/{{email}}', settings)
        .then(data => {
          // El usuario existe
          item.id = data.id;
          // Valida si el usuario ya ha sido agregado anteriormente
          if(data.userProfiles.length < 1){
            // Se llama la Lambda attachProfile por cada uno de los roles
            item.profiles.forEach(async (role, index, array) => {
              this.attachProfile(item.id, role).then(() => {
                if (index === array.length - 1){
                  this.loadUsers(this.filter);
                }
              });
            })
          } else{
            // Lanza error de usuario existente
            console.log('AttachProfileError: El usuario ya se encuentra agregado')
            this.snackbarMessage = this.$t('errorDuplicate');
            this.snackbar = true;
          }
        })
        .catch(e => {
          // El usuario no existe
          console.log(e);
          console.log('AttachProfile: El usuario no existe');
          this.snackbarMessage = this.$t('errorUserNotFound');
          this.snackbar = true;
        });
      },
      /**
       * Agrega un perfil a un usuarioo
       * @param userId Id del usuario
       * @param role Perfil que se agregará
       */
      async attachProfile(userId, role){
        return new Promise((resolve, reject) => {
          let body = {
            params: {
              userId: userId,
              profileId: role
            },
            data: {}
          };
          this.$POST("/api/users/{{userId}}/profile/{{profileId}}", body)
          .then(() => {
            // Perfil Agregado correctamente
            console.log('AttachProfiel: Usuario agregado');
            resolve(true);
          })
          .catch(e => { 
            // error al agregar perfil
            console.log('AttachProfiel: Error al agregar Perfil');
            console.log(e);
            reject(e);
          });
        });
      },

      delete(item){
        let roles = item.userProfiles.map(profile => {
          return profile.profileId;
        })
        this.detachProfile(item, roles).then(() => {
          this.loadUsers(this.filter);
        });
      },

      edit(item){
        let roles = item.userProfiles.map(profile => {
          return profile.profileId;
        })
        this.detachProfile(item, roles).then(() =>{
          this.addProfile(item);
        });
      },
      /**
       * Elimina un perfil de un usuario
       * @param item Datos del usuario
       * @param roles Array con los perfiles a eliminar
       */
      async detachProfile(item, roles){
        return new Promise((resolve, reject) => {
          roles.forEach( (role, index, array) => {
            // Busca el user profile correspondiente al role
            let profile = item.userProfiles.find( profile => profile.profileId == role);
            // Si existen los datos llama a lambda
            if (profile){
              let body = {
                params: {
                  userId: item.id,
                  profileId: role
                },
                data: {
                  id: profile.id,
                  lastUpdate: profile.lastUpdate
                }
              };
              this.$DELETE("/api/users/{{userId}}/profile/{{profileId}}", body)
              .then(() => {
                // Perfil eliminado
                console.log('AttachProfiel: Usuario agregado');
                if (index === array.length - 1){
                  resolve(true);
                }
              })
              .catch(e => { 
                // error al eliminar perfil
                console.log('AttachProfiel: Error al agregar Perfil');
                console.log(e);
                reject(e);
              });
            }
          });
        });
      },

      canDelete(email){
        return email.toLowerCase() != this.email.toLowerCase();
      },
      /**
       * Carga los perfiles disponibles
       */
      loadProfiles(){
        this.$GET('/api/profiles', [])
        .then(data => {
          this.profiles = data;
          this.loadUsers(this.filter);
        })
        .catch(e => {
          console.log(e)
        });
      }
    },
  }
</script>